module.exports = __webpack_public_path__ + "static/media/yt.9d0be1d4.svg";